import { render, staticRenderFns } from "./KpiFolder.vue?vue&type=template&id=2ee09033&scoped=true&"
import script from "./KpiFolder.vue?vue&type=script&lang=ts&"
export * from "./KpiFolder.vue?vue&type=script&lang=ts&"
import style0 from "./KpiFolder.vue?vue&type=style&index=0&id=2ee09033&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee09033",
  null
  
)

export default component.exports